export default "__VITE_ASSET__a3cf6a50__"